import React, {useEffect, useState} from "react";
import DashboardLayout from "../../../layouts/Dashboard";

import DictionaryCRUDTable from "../../../components/CRUD/Tables/DictionaryCRUDTable";

const ReferralAdditionalInfoList = () => {    
    return (
        <DashboardLayout>
            <DictionaryCRUDTable
                entityType="referralAdditionalInfo"
                hasCode={true}
                hasDescription={true}
            />
        </DashboardLayout>
    )
};

export default ReferralAdditionalInfoList;
